import {CommonService} from '../../services/common.service';
import {Component, Inject} from '@angular/core';
import {ConfirmActionDialogComponent} from '../../common/confirm-action-dialog/confirm-action-dialog.component';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';

@Component({
  styleUrls: ['./initialize-sums-dialog.component.scss'],
  templateUrl: './initialize-sums-dialog.component.html'
})
export class InitializeSumsDialogComponent {
  public materials: any;

  constructor(private commonService: CommonService,
              private matDialog: MatDialog,
              private matDialogRef: MatDialogRef<InitializeSumsDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.materials = this.data.materials;
    this.materials.forEach(material => {
      material.sum = 0;
    });
    this.matDialogRef.updateSize('50', '50');
    this.commonService.tempDialogReference = this.matDialogRef;
  }

  public closeDialog(): void {
    try {
      this.matDialogRef.close();
    } catch (e) {
    }
  }

  public isSummariesFormValid(): boolean {
    const disabled = false;
    // this.materials.forEach(material => {
    //   if (material.sum === 0) {
    //     disabled = true;
    //   }
    // });

    return disabled;
  }

  public async submitSums(materials: any) {
    try {
      this.matDialogRef = this.commonService.tempDialogReference;
      this.matDialogRef.close(materials);
      // await this.purchaseOrdersService.storeLoadingCommand('request/web', model);
      // this.dialog.open(ActionCompletionDialogComponent, {
      //   data: {
      //     buttonText: 'Πλοήγηση στα Budget Ψυγείων',
      //     redirectURL: `refrigerator-budget`
      //   }
      // });
    } catch (e) {
    }
  }

  public async confirmInitialization() {
    this.matDialog.open(ConfirmActionDialogComponent, {
      data: {
        confirmFunction: () => {
          this.submitSums(this.materials);
        },
        message: `Είστε σίγουροι ότι θέλετε να αρχικοποιήσετε τα σύνολα για τη χρονιά ${this.data.year}; Μετά την αρχικοποίηση δε θα μπορείτε να αλλάξετε τις τιμές.`,
        title: 'Αρχικοποίηση συνόλων'
      }
    });
  }
}
